import SystemSettingModel from './SystemSettingModel'

var SystemSetting = new SystemSettingModel()
export default SystemSetting



// WEBPACK FOOTER //
// ./src/View/SystemSetting/SystemSettingApi/SystemSetting.js